import React, { useState, useEffect, useCallback } from "react"
import axiosConfig from "../Service/axiosConfig"
import { MdOutlineModeEditOutline, MdDeleteOutline } from "react-icons/md";
import { useScrollContext } from "../Utils/ScrollContext";
import { ExploreGrid } from "./exploregrid";


const ProfileShortlist = ({ ProfileData, can_edit_profile }) => {
    const [Data, SetData] = useState([])
    const [EditFormData, SetEditFormData] = useState([])
    const [DeleteEnabled, SetDeleteEnabled] = useState(false)
    const [ModelShow, setModelShow] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
    const [nextUrl, setNextUrl] = useState(null);
    const { registerLoadMore } = useScrollContext();
    const [loading2, setLoading2] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 1020);
    };
    const GetData = async () => {
        setLoading(true)
        try {
            const responce = await axiosConfig.get(`/accounts/shortlists/?user=${ProfileData.user.id}&page_size=20`)
            console.log(responce.data.results)
            const profiles = responce.data.results.map((item) => item.profile);
            SetData(profiles)
            setNextUrl(responce.data.next);
            setLoading(false)
        }
        catch (error) {
            console.log(error)
            setLoading(false)
        }
    }
    const handleInfiniteScroll = useCallback(async () => {
        if (loading2 || !nextUrl) return;
        setLoading2(true);
        try {
            const resp = await axiosConfig.get(nextUrl);
            const profiles = resp.data.results.map((item) => item.profile);
            SetData((prev) => [...prev, ...profiles]);
            setNextUrl(resp.data.next);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading2(false);
        }
    }, [loading2, nextUrl]);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        GetData();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [])
    useEffect(() => {
        registerLoadMore(handleInfiniteScroll);
        return () => registerLoadMore(null);
    }, [handleInfiniteScroll, registerLoadMore]);
    return (
        <>
            {loading ? (
                <div className="loader-container">
                    <img src={require('./images/loader.gif')} alt="Loading..." />
                </div>
            ) : (
                <div className="container">
                    <div className="search-screen-container search-page" style={{ overflow: "hidden" }}>
                        <div className="content-area" style={{ position: "relative" }}>
                            <ExploreGrid Data={Data} loading={loading} loading2={loading2} />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
export { ProfileShortlist };